import React from 'react';
import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';
import { Link } from '..';
import Carousel, { Props as CarouselProps } from '../carousel/carousel';
import './related-carousel.scss';
import type { CardSlide } from '../carousel/slider';

interface LinkProps {
    href: string;
    text: string;
}

interface DeviceProps {
    type?: string;
}

interface RelatedCarouselProps
    extends Pick<CarouselProps, 'breakpoints' | 'hasControls' | 'endTracking'> {
    slides?: CardSlide[];
    title?: string | null;
    link?: LinkProps | null;
    linkTracking?: string | null;
    device?: DeviceProps;
    onItemClick?: (event: React.MouseEvent, slide: any) => void;
}

const RelatedCarousel: React.FC<RelatedCarouselProps> = ({
    slides = [],
    breakpoints = [],
    title = null,
    link = null,
    hasControls = true,
    endTracking = '',
    linkTracking = null,
    device = {},
    onItemClick,
}) => (
    <div className="related-carousel carousel">
        {(title || link) && (
            <div className="related-carousel-topBar">
                {title && <h4 className="related-carousel-title">{title}</h4>}
                {link && (
                    <Link
                        className="related-carousel-link"
                        href={link.href}
                        onClick={() => linkTracking && trackV2(linkTracking)}
                    >
                        {link.text}
                    </Link>
                )}
            </div>
        )}
        <Carousel
            slides={slides}
            breakpoints={breakpoints}
            itemsToShow={6}
            device={device.type}
            showNextSlidePreview
            hasControls={hasControls}
            hasIcon={false}
            hasCounter={false}
            hasZoom={false}
            endTracking={endTracking}
            isSimilarResults
            onItemClick={onItemClick}
        />
    </div>
);

export default RelatedCarousel;
